import * as React from 'react';
import { IntlContext } from './IntlContext';
/**
 * React hook for using intl formatter functions
 */
export function useIntl() {
    var intl = React.useContext(IntlContext);
    if (!intl) {
        throw new Error([
            '[NUI Intl Runtime] You are consuming a function/component of NUI Intl Library. ',
            '',
            'However, required `intl` object could not be found.',
            'Make sure <IntlProvider> exist in the component ancestry.',
            '',
        ].join('\n'));
    }
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        React.useDebugValue(intl, getDebugValue());
    }
    return intl;
}
export function getDebugValue() {
    return function (value) {
        var messages = "".concat(Object.keys(value.preferences.messages).length, " messages");
        var locale = "\"".concat(value.preferences.locale, "\" locale");
        return "".concat(locale, " with ").concat(messages);
    };
}
